import { RETRIEVE_NOTIFICATIONS } from "../actions/notifications/types";
import { Notifications } from "./state";
import { AnyAction } from "redux";
import { Reducer } from "react";

const initialState: Notifications = {
    data: {
        todays: [],
        earlier: [],
    },
    unseenCount: 0,
    numberOfRecords: 0,
};

const notificationReducer: Reducer<Notifications, AnyAction> = (
    state = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;
    const todays: any[] = [];
    const earlier: any[] = [];
    const intervals = [
        { label: "year", seconds: 31536000 },
        { label: "month", seconds: 2592000 },
        { label: "day", seconds: 86400 },
        { label: "hour", seconds: 3600 },
        { label: "minute", seconds: 60 },
        { label: "second", seconds: 1 },
    ];

    function timeSince(date) {
        const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
        const interval = intervals.find((i) => i.seconds < seconds);
        const count = Math.floor(seconds / interval.seconds);
        return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
    }
    if (payload?.data?.records) {
        payload.data.records.map((r) => {
            if (r.age.days) {
                earlier.push(r);
            } else {
                todays.push(r);
                r.hours_ago = timeSince(new Date(r.created_at));
            }
        });
        payload.data.records = { todays, earlier };
    }

    switch (type) {
        case RETRIEVE_NOTIFICATIONS:
            return {
                ...state,
                data: payload?.data.records,
                unseenCount: payload?.data.unseen,
                numberOfRecords: payload?.data?.total,
            };

        default:
            return state;
    }
};

export default notificationReducer;
